// extracted by mini-css-extract-plugin
export default {"container":"Uo-z","ratingLayout":"Vo-z","ratingLabel":"Wo-z","nonInteractiveRatingLabel":"Xo-z"};